import connect from '../axios/axios.auth';

const clientFunction =  {
  register: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/cliente/`, { data })
      .then((response) => {
        resolve(response)
      })
    })
  },
  update: (data) => {
    return new Promise((resolve, reject) => {
      connect.put(`/cliente/`, { data })
      .then((response) => {
        resolve(response)
      })
    })
  },
  listado: () => {
    return new Promise((resolve, reject) => {
      connect.get(`/cliente/`)
      .then((response) => {
        resolve(response)
      })
    })
  },
  listadoV2: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/cliente/v2`, { ...data })
      .then((response) => {
        resolve(response)
      })
    })
  },
  listadoFull: () => {
    return new Promise((resolve, reject) => {
      connect.get(`/cliente/full`)
      .then((response) => {
        resolve(response.data)
      })
    })
  },
  activar: (data) => {
    return new Promise((resolve) => {
      connect.post(`/cliente/remover`, data)
      .then((response) => {
        resolve(response.data);
      })
    })
  },
  changeStatus: (list, id) => {
    const index = list.findIndex((e) => e.id === id);
    const actualValue = list[index].status;
    list[index].status = actualValue ? 0 : 1;
    return list;
  }
}

export default clientFunction;